export default __webpack_public_path__ + "assets/star-filled-component.ca2c7beb.svg";